import { configureStore } from "@reduxjs/toolkit";

import common from "../features/admin/common/Slice";

import contactus from "./contactus";

import quizContactus from "./quizContactUs";

import quiz from "../features/admin/quiz/Slice";

import auth from "./auth";

//store
export const store = configureStore({
  reducer: {
    common: common,

    contactus,

    quizContactus,

    quiz,

    auth,
  },
});
